import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const personalInfoSchema = yup
  .object({
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required")
      .max(40, "Maximum of 40 characters is allowed"),

    phoneNumber: yup
      .string()
      .matches(/^[0-9]+$/, "Phone number must contain only digits")
      .test("num", "Invalid phone number format", (val) => !val.startsWith("0"))
      .min(9, "Invalid phone number format")
      .max(11, "Invalid phone number format")
      .required("Phone number is required"),

    firstName: yup
      .string()
      .min(2, "Minimum of 2 characters is allowed")
      .max(30, "Maximum of 30 characters is allowed")
      .required("First name is required"),

    lastName: yup
      .string()
      .min(2, "Minimum of 2 characters is allowed")
      .max(30, "Maximum of 30 characters is allowed")
      .required("Last name is required"),
    jobTitle: yup.string().max(30, "A maximum of 30 characters"),
  })
  .required();

const ProfilePersonalInfoFormValidation = (
  email,
  firstName,
  lastName,
  phoneNumber,
  jobTitle,
) => {
  return useForm({
    resolver: yupResolver(personalInfoSchema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      email: email,
      firstName: firstName,
      lastName: lastName,
      phoneNumber: phoneNumber,
      jobTitle: jobTitle,
    },
  });
};

export default ProfilePersonalInfoFormValidation;
